import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useTranslation } from '../i18n';
export function TripppOpsPage() {
  const {
    t
  } = useTranslation();
  return <div className="pt-24" data-id="element-606">
      <section className="relative py-24 lg:py-32 overflow-hidden" data-id="element-607">
        <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-608">
          <div className="aurora-blob bg-[#00E5FF] w-[600px] h-[600px] top-[-10%] right-[-10%] animate-aurora-1" data-id="element-609"></div>
          <div className="aurora-blob bg-[#7B2FFF] w-[800px] h-[800px] bottom-[-20%] left-[-10%] animate-aurora-2" data-id="element-610"></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-611">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-612">
            <div data-id="element-613">
              <div className="inline-block px-4 py-1.5 rounded-full border border-white/10 bg-white/5 mb-6" data-id="element-614">
                <span className="text-sm font-bold text-gradient uppercase tracking-wider" data-id="element-615">
                  {t('tripppOps.badge')}
                </span>
              </div>
              <h1 className="text-5xl lg:text-7xl font-bold leading-[1.1] mb-6" data-id="element-616">
                {t('tripppOps.heroTitle')}
                <span className="text-gradient" data-id="element-617">
                  {t('tripppOps.heroTitleHighlight')}
                </span>
              </h1>
              <p className="text-xl text-white/60 mb-10 leading-relaxed" data-id="element-618">
                {t('tripppOps.heroDesc')}
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-619">
                <a href="https://calendar.app.google/kAzzsMuwfngdzNZf9" target="_blank" rel="noopener noreferrer" className="bg-gradient-animated rounded-full px-8 py-4 text-base font-semibold text-white text-center hover:scale-105 transition-transform duration-300 shadow-[0_0_30px_rgba(0,229,255,0.3)]" data-id="element-620">
                  {t('tripppOps.bookDemo')}
                </a>
                <button type="button" className="rounded-full border border-white/20 px-8 py-4 text-base font-semibold text-white text-center hover:border-transparent hover:bg-white/5 transition-all duration-300 relative group overflow-hidden" data-id="element-621">
                  <div className="absolute inset-0 bg-gradient-animated opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{
                  padding: '1px',
                  WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                  WebkitMaskComposite: 'xor',
                  maskComposite: 'exclude'
                }} data-id="element-622"></div>
                  <span className="relative z-10" data-id="element-623">
                    {t('tripppOps.seeHowItWorks')}
                  </span>
                </button>
              </div>
            </div>
            <div className="relative h-[500px] rounded-3xl border border-white/10 bg-[#0A0A0A] overflow-hidden shadow-2xl flex" data-id="element-624">
              <div className="w-1/2 border-r border-white/10 p-8 flex items-center justify-center bg-[#050505]" data-id="element-625">
                <div className="w-48 h-96 rounded-[2rem] border-4 border-[#222] bg-[#111] p-2 relative overflow-hidden" data-id="element-626">
                  <div className="w-full h-32 bg-gradient-to-br from-[#FF6B00]/20 to-transparent rounded-xl mb-4" data-id="element-627"></div>
                  <div className="space-y-3 px-2" data-id="element-628">
                    <div className="h-4 w-3/4 bg-white/20 rounded" data-id="element-629"></div>
                    <div className="h-3 w-1/2 bg-white/10 rounded" data-id="element-630"></div>
                    <div className="h-12 w-full bg-white/5 rounded-lg mt-6 border border-white/10" data-id="element-631"></div>
                    <div className="h-12 w-full bg-white/5 rounded-lg border border-white/10" data-id="element-632"></div>
                  </div>
                </div>
              </div>
              <div className="w-1/2 p-8 bg-[#0A0A0A]" data-id="element-633">
                <div className="w-full h-full rounded-xl border border-white/10 bg-[#111] p-4 flex flex-col gap-4" data-id="element-634">
                  <div className="flex justify-between items-center border-b border-white/10 pb-4" data-id="element-635">
                    <div className="h-4 w-1/3 bg-white/20 rounded" data-id="element-636"></div>
                    <div className="h-6 w-16 bg-gradient-animated rounded-full" data-id="element-637"></div>
                  </div>
                  <div className="grid grid-cols-2 gap-4" data-id="element-638">
                    <div className="h-16 bg-white/5 rounded-lg border border-white/10" data-id="element-639"></div>
                    <div className="h-16 bg-white/5 rounded-lg border border-white/10" data-id="element-640"></div>
                  </div>
                  <div className="flex-1 bg-white/5 rounded-lg border border-white/10 mt-2" data-id="element-641"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#050505] relative z-20 border-t border-white/5" data-id="element-642">
        <div className="max-w-7xl mx-auto px-6" data-id="element-643">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-644">
            {t('tripppOps.travelerTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-645">
            {[0, 1, 2, 3, 4, 5].map(idx => <div key={idx} className="bg-[#0A0A0A] border border-white/10 rounded-2xl p-8 hover:border-white/20 transition-colors" data-id="element-646">
                <h3 className="text-xl font-bold mb-3 text-gradient" data-id="element-647">
                  {t(`tripppOps.traveler${idx}Title`)}
                </h3>
                <p className="text-white/60 leading-relaxed" data-id="element-648">
                  {t(`tripppOps.traveler${idx}Desc`)}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-649">
        <div className="max-w-7xl mx-auto px-6" data-id="element-650">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-651">
            {t('tripppOps.agencyTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-652">
            {[0, 1, 2, 3, 4].map(idx => <div key={idx} className="bg-[#050505] border border-white/10 rounded-2xl p-8 hover:border-white/20 transition-colors" data-id="element-653">
                <h3 className="text-xl font-bold mb-3 text-white" data-id="element-654">
                  {t(`tripppOps.agency${idx}Title`)}
                </h3>
                <p className="text-white/60 leading-relaxed" data-id="element-655">
                  {t(`tripppOps.agency${idx}Desc`)}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#050505] relative z-20 border-t border-white/5" data-id="element-656">
        <div className="max-w-5xl mx-auto px-6" data-id="element-657">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-658">
            {t('tripppOps.mandatesTitle')}
          </h2>
          <div className="space-y-8" data-id="element-659">
            {[0, 1].map(idx => <div key={idx} className="flex items-stretch p-8 bg-[#0A0A0A] rounded-2xl border border-white/5" data-id="element-660">
                <div className="w-1.5 rounded-full bg-gradient-animated mr-8 shrink-0" data-id="element-661"></div>
                <p className="text-xl text-white/80 leading-relaxed italic" data-id="element-662">
                  "{t(`tripppOps.scenario${idx}`)}"
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#050505] relative z-20 border-t border-white/5" data-id="element-663">
        <div className="max-w-4xl mx-auto px-6" data-id="element-664">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-665">
            {t('tripppOps.deploymentTitle')}
          </h2>
          <div className="max-w-4xl mx-auto" data-id="element-666">
            <div className="group relative rounded-3xl overflow-hidden bg-[#050505] min-h-[300px]" data-id="element-667">
              <div className="absolute inset-0 border border-white/10 rounded-3xl group-hover:opacity-0 transition-opacity duration-300" data-id="element-668"></div>
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 border-gradient-animated rounded-3xl" data-id="element-669"></div>
              <div className="relative h-full p-10 flex flex-col justify-end z-10" data-id="element-670">
                <h3 className="text-3xl font-bold mb-4 text-white" data-id="element-671">
                  {t('tripppOps.deployment0Title')}
                </h3>
                <p className="text-white/60 text-lg leading-relaxed mb-8" data-id="element-672">
                  {t('tripppOps.deployment0Desc')}
                </p>
                <button type="button" className="inline-flex items-center text-sm font-semibold text-gradient group-hover:tracking-wide transition-all duration-300" data-id="element-673">
                  {t('tripppOps.learnMore')}{' '}
                  <ArrowRightIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-674" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#050505] relative z-20 border-t border-white/5" data-id="element-675">
        <div className="max-w-5xl mx-auto px-6 text-center" data-id="element-676">
          <h2 className="text-3xl md:text-5xl font-bold mb-16" data-id="element-677">
            {t('tripppOps.pricingTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-678">
            <div className="bg-[#0A0A0A] border border-white/10 rounded-2xl p-8 border-gradient-animated" data-id="element-679">
              <div className="relative z-10" data-id="element-680">
                <h3 className="text-xl font-medium text-white mb-2" data-id="element-681">
                  {t('tripppOps.platformLicense')}
                </h3>
                <div className="flex items-baseline justify-center gap-2 mb-4" data-id="element-682">
                  <p className="text-3xl font-bold text-gradient" data-id="element-683">€4,800</p>
                  <span className="text-lg text-white/40 font-normal" data-id="element-684">
                    {t('pricing.year')}
                  </span>
                  <span className="text-white/40 mx-2" data-id="element-685">+</span>
                  <p className="text-3xl font-bold text-gradient" data-id="element-686">€500</p>
                  <span className="text-lg text-white/40 font-normal" data-id="element-687">
                    {t('pricing.op')}
                  </span>
                </div>
                <p className="text-sm text-white/60 leading-relaxed" data-id="element-688">
                  {t('pricing.platformLicenseDesc')}
                </p>
              </div>
            </div>
            <div className="bg-[#0A0A0A] border border-white/10 rounded-2xl p-8" data-id="element-689">
              <div className="flex justify-between items-start mb-2" data-id="element-690">
                <h3 className="text-xl font-medium text-white" data-id="element-691">
                  {t('pricing.singleOperation')}
                </h3>
                <span className="px-3 py-1 bg-white/5 border border-white/10 rounded-full text-xs text-white/60" data-id="element-692">
                  {t('pricing.noCommitment')}
                </span>
              </div>
              <p className="text-3xl font-bold text-white mb-4" data-id="element-693">
                €3,000{' '}
                <span className="text-lg text-white/40 font-normal" data-id="element-694">
                  {t('pricing.oneTimeLabel')}
                </span>
              </p>
              <p className="text-sm text-white/60 leading-relaxed" data-id="element-695">
                {t('pricing.singleOperationDesc')}
              </p>
            </div>
          </div>
          <p className="text-white/40 mb-8" data-id="element-696">{t('tripppOps.noPriceNote')}</p>
          <Link to="/pricing" className="inline-flex items-center text-lg font-semibold text-gradient hover:tracking-wide transition-all duration-300" data-id="element-697">
            {t('tripppOps.seeFullPricing')}{' '}
            <ArrowRightIcon className="w-5 h-5 ml-2" data-id="element-698" />
          </Link>
        </div>
      </section>

      <section className="relative py-32 overflow-hidden bg-[#0A0A0A] border-t border-white/5" data-id="element-699">
        <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-50" data-id="element-700">
          <div className="aurora-blob bg-[#CC00FF] w-[400px] h-[400px] top-[10%] left-[20%] animate-aurora-2" data-id="element-701"></div>
          <div className="aurora-blob bg-[#2563EB] w-[500px] h-[500px] bottom-[10%] right-[20%] animate-aurora-1" style={{
          animationDirection: 'reverse'
        }} data-id="element-702"></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-703">
          <h2 className="text-4xl md:text-6xl font-bold mb-12" data-id="element-704">
            {t('tripppOps.ctaTitle')}
            <span className="text-gradient" data-id="element-705">{t('tripppOps.ctaHighlight')}</span>
          </h2>
          <a href="https://calendar.app.google/kAzzsMuwfngdzNZf9" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-animated rounded-full px-10 py-5 text-lg font-bold text-white hover:scale-105 transition-transform duration-300 shadow-[0_0_40px_rgba(0,229,255,0.3)]" data-id="element-706">
            {t('tripppOps.ctaCta')}
          </a>
        </div>
      </section>
    </div>;
}